import cn from 'classnames'
import React from 'react'

import { isMixed } from 'components/uiKit/KitUtils'
import { testProps } from 'utils/test/qaData'

import type { IKitControlProps } from '../KitTypes'
import * as s from './Switcher.module.scss'

export interface ISwitcherProps extends IKitControlProps<boolean> {
  label?: string | React.ReactNode
  labelPosition?: 'left' | 'right'
}

const Switcher = ({
  onChange,
  name,
  defaultValue,
  value = defaultValue ?? false,
  disabled,
  labelPosition = 'right',
  label,
}: ISwitcherProps) => {
  const safeValue = isMixed(value) ? false : (value as boolean)
  const handleChange = () => onChange?.(!safeValue)

  return (
    <label className={s.root}>
      {label && labelPosition === 'left' && <span className={s.label}>{label}</span>}
      <div className={s.switch}>
        <input
          checked={safeValue}
          disabled={disabled}
          name={name}
          onChange={handleChange}
          type='checkbox'
        />
        <span
          className={cn(s.slider, { [s.disabled]: disabled, [s.active]: !safeValue })}
          {...testProps({ el: 'switch', name, checked: safeValue })}
        />
      </div>
      {label && labelPosition === 'right' && <span className={s.label}>{label}</span>}
    </label>
  )
}

export default Switcher
